import { useCallback, useState } from "react";
import { useSnackbar } from "notistack";
import {
  fetchDocumentCategoryMappings,
  fetchUnmappedCategories,
  createDocumentCategoryMapping,
  updateDocumentCategoryMapping,
  deleteDocumentCategoryMapping,
  reapplyDocumentCategoryMappings,
} from "@accredo/fe-shared/services/documentCategoryMappingService.js";

export function useDocumentCategoryMappingActions() {
  const { enqueueSnackbar } = useSnackbar();
  const [mappings, setMappings] = useState([]);
  const [unmappedCategories, setUnmappedCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasLoaded, setHasLoaded] = useState(false);

  const load = useCallback(() => {
    setIsLoading(true);
    return fetchDocumentCategoryMappings()
      .then((res) => {
        setMappings(res.data ?? []);
        setHasLoaded(true);
      })
      .catch(() =>
        enqueueSnackbar("Kategorie-Zuordnungen konnten nicht geladen werden", {
          variant: "error",
        })
      )
      .finally(() => setIsLoading(false));
  }, [enqueueSnackbar]);

  const loadUnmapped = useCallback(() => {
    return fetchUnmappedCategories()
      .then((res) => setUnmappedCategories(res.data ?? []))
      .catch(() =>
        enqueueSnackbar("Verfügbare Kategorien konnten nicht geladen werden", {
          variant: "error",
        })
      );
  }, [enqueueSnackbar]);

  const create = async (payload) => {
    const result = await createDocumentCategoryMapping(payload);
    await Promise.all([load(), loadUnmapped()]);
    return result;
  };

  const update = async (mapping_id, payload) => {
    const result = await updateDocumentCategoryMapping(mapping_id, payload);
    await load();
    return result;
  };

  const remove = async (mapping_id) => {
    await deleteDocumentCategoryMapping(mapping_id);
    await Promise.all([load(), loadUnmapped()]);
  };

  const reapply = async () => {
    const result = await reapplyDocumentCategoryMappings();
    await load();
    return result;
  };

  return {
    mappings,
    unmappedCategories,
    isLoading,
    hasLoaded,
    load,
    loadUnmapped,
    create,
    update,
    remove,
    reapply,
  };
}
